module.exports = __webpack_public_path__ + "img/life-insurance-lifebuoy.134a0d1.webp";